// Webpack Imports


import * as bootstrap from 'bootstrap';

//import './components/_functions';
import './components/_age_gate';
import './components/_header';
import './components/_footer';
import './components/_video-modal';
import './blocks/_buy';
import './blocks/_header';
import './blocks/_medias-carousel';
import './blocks/_slider';
import './blocks/_half-size-section';



[].map.call(document.querySelectorAll('.slider-item:not(.active)'), function(element) {
    element.classList.add('hide');
});


function initBuyButton () {
	const options = {
		project_id: "204292",
		sku: "ravenswatch",
		item_type: "unit",
		user: {
			locale: _locale,
		},
		api_settings: {
			sandbox: false,
		},
		widget_ui: {
			template: 'simple',
			target_element: "#buy-button",
		},
		access_data: {
			settings: {
				ui: {
					theme: "dark"
				}
			}
		},
		payment_widget_ui: {
			lightbox: {
				width: '740px',
				height: '735px',
				spinner: 'round',
				spinnerColor: '#ffffff',
				contentBackground: "rgba(0,0,0,0.5)"
			}
		}
	};

	const s = document.createElement('script');
	s.type = "text/javascript";
	s.async = true;
	s.src = "https://cdn.xsolla.net/embed/buy-button/3.1.8/widget.min.js";
	s.addEventListener('load', () => {
		XBuyButtonWidget.create(options);
	}, false);

	const head = document.getElementsByTagName('head')[0];
	head.appendChild(s);
}

( function () {
	'use strict';

	if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
		// the user is using a mobile device, so redirect to the mobile version of the website
		$('body').addClass('mobile');
	}

	if (window.jQuery) {

		// Dealing with nav anchor items to let Jquery handle scroll behavior
		$('#header li.anchor .nav-link').each(function () {
			var _href = $(this).attr('href');
			$(this).attr('data-anchor', _href);
			$(this).attr('href', 'javascript:void(0);');
		});
	}

} )();

